export const OTHER_CATEGORY = 'Autres'
export const SUPPLIER_REFINEMENT = 'menu[supplier]'
export const DISJUNCTIVE_FACETS = [
  'organic',
  'is_off_season',
  'is_highlighted',
  'is_exclusive',
  'has_discount',
  'crops',
  'nutritive_elements',
  'active_substances',
  'valuation',
  'variants.precocity',
  'specificity',
  'material',
  'crop_types',
  'product_type',
  'color',
  'variants.length_mm',
  'variants.height_mm',
  'ball_type',
  'activity_area',
  'thickness',
  'tear_resistance',
  'variants.surface',
  'variants.section_mm',
  'knot_resistance',
  'variants.width_mm',
  'weight_in_gramm_per_square_meter',
  'variants.mesh_size_mm',
  'is_biodegradable',
  'supplier',
  'supplier_refinement',
  'variants.label_certification',
  'precocity_corn_group',
  'variants.crop_protection_label',
  'profile',
  'precocity_with_spike',
  'aristation',
  'alternation',
  'number_of_ranks',
  'crop_oad',
  'flea_beetle_behaviour_oad',
  'honey_beetle_trap',
  'variants.anti_crows_oad',
  'aristation_oad',
  'precocity_group_oad',
  'resistance_oad_herbicide',
  'orobranch_oad_risk',
  'risk_replacement_hernia_oad',
  'soil_potential_oad',
  'risk_flea_beetles_oad',
  'brand',
  'grain_type',
  'item_number',
  'malt_type',
  'material_gen',
  'origin',
  'product_color',
  'result_of_organic_farming',
  'sanitation_subcategory',
  'style',
  'yeast_subcategory',
  'is_mention_bio_control',
  'is_supplier_highlighted',
  'precocite_oleo_proteaginous_maturity',
  'grain_color',
  'variants.inoculant',
]
